import React from 'react'
import { Link } from 'react-router-dom'
import config from '../../config'

// Todo: Anderer Link (nicht assets/..)
// background Image oder so
const SidebarLogo = () => (
    <div className="logo-wrapper">
        <Link className="logo" to={config.routes.dashboard.path}/>
    </div>
)

export default SidebarLogo